import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";
import horizontalLoop from "@js/utils/gsapHorizontalLoop";

gsap.registerPlugin(ScrollTrigger);

function cloneHTMLElement(item, n = 2, parent = null) {
  if (parent == null) parent = item.parentNode;

  Array.from({ length: n }).forEach(() => parent.append(item.cloneNode(true)));
}

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".scroll-text-loop");

  blocks.forEach((block) => {
    const trail = block.querySelector(".scrolling-text__trail");
    const text = trail.querySelector(":first-child");
    // create 2 more text html elements to create a loop effect
    cloneHTMLElement(text, 2, trail);

    const scrollingText = gsap.utils.toArray(trail.children);

    const tl = horizontalLoop(scrollingText, {
      repeat: -1,
    });

    let speedTween;

    ScrollTrigger.create({
      trigger: ".scrolling-text",
      start: "top bottom",
      end: "bottom top",
      onUpdate: (self) => {
        speedTween && speedTween.kill();
        speedTween = gsap
          .timeline()
          .to(tl, {
            timeScale: 3 * self.direction,
            duration: 0.25,
          })
          .to(
            tl,
            {
              timeScale: 1 * self.direction,
              duration: 1.5,
            },
            "+=0.5"
          );
      },
    });

    // Observer.create({
    //   onChangeY(self) {
    //     let factor = 2.5;
    //     if (self.deltaY < 0) {
    //       factor *= -1;
    //     }
    //     gsap
    //       .timeline({
    //         defaults: {
    //           ease: "none",
    //         },
    //       })
    //       .to(tl, { timeScale: factor * 2.5, duration: 0.2 })
    //       .to(tl, { timeScale: factor / 2.5, duration: 1 }, "+=0.3");
    //   },
    // });
  });
});
